import App from './core/App';
import CDSLoader from './loader/CDSLoader';
import LibraryLoader from './loader/LibraryLoader';
import LibraryController from './controllers/LibraryController';
import InteractiveCatalogController from './controllers/InteractiveCatalogController';
import BrowserUtils from './util/BrowserUtils';
import URLUtils from './util/URLUtils';
import CDSFilter from './util/CDSFilter';
import LibraryCatalogFilter from './util/LibraryCatalogFilter';

export default class WebViewer extends App {

    constructor(args) {
        super();

        this.currentViewerVersion = '0.7.10';
        this.currentDeviceType = 'WEB';
        this.currentOrientation = 'HORIZONTAL';

        this.userLanguageList = BrowserUtils.getUserLanguages();
        this.viewerLanguageList = ['en', 'es', 'zh'];
        this.deviceLanguageList = undefined;
        this.defaultLanguage = 'en';
        this.currentDeviceLanguage = undefined;
        
        this.baseUrl = (args['baseUrl']) ? args['baseUrl'] : '/export/';
        if (this.baseUrl.charAt(this.baseUrl.length-1) != '/')
            this.baseUrl += '/';

        this.libraryId = (args['libraryId']) ? args['libraryId'] : 'testintelligentfolders';
        this.cds = (args['cds']) ? (args['cds'] == "true" || args['cds'] == true) : false;
        this.catalogId = (args['catalogId']) ? args['catalogId'] : ((args['catalog']) ? args['catalog'] : undefined);

        this.library = null;
        this.visualTemplate = null;
        this.cdsConfig = null;

        this.viewStack = [];

        this.bannerSliderOptions = {};

        this.polyglot = new Polyglot();

        // Register controllers
        this.registerController('LibraryController', new LibraryController());
        this.registerController('InteractiveCatalogController', new InteractiveCatalogController());

        this.initializePolyfills();

        // Events
        $(window).resize(this.onResize.bind(this));
    }

    run() {

        this.printHeader();

        // Favicon
        $("link[rel*='icon']").attr("href", URLUtils.getURL(this.baseUrl + "img/favicon.png"));

        // Comprobar si el navegador está soportado
        if (!this.isSupportedBrowser()) {
            $('#COIWebViewer').empty();

            let d = $('<div>', {
                title: 'Error',
                html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span> El navegador no está soportado.</p>'
            }).dialog({
                modal: true,
                closeOnEscape: false,
                open: function(event, ui) { $(".ui-dialog-titlebar-close", ui.dialog | ui).hide(); }
            });
        }

        this.currentDeviceLanguage = this.chooseLanguage(this.userLanguageList, this.viewerLanguageList, this.defaultLanguage);
        this.loadMessages().done(() => {
            // Comprobar si la aplicación está ejecutandose como fichero local
            if (!window.location.protocol.includes('http')) {
                $('#COIWebViewer').empty();

                let d = $('<div>', {
                    title: 'Error',
                    html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span> La aplicación no está ejecutandose desde un servidor.</p>'
                }).dialog({
                    modal: true,
                    closeOnEscape: false,
                    open: function(event, ui) { $(".ui-dialog-titlebar-close", ui.dialog | ui).hide(); }
                });
            } else if (this.cds) {
                this.loadCDSConfig()
                    .done(() => {

                        let cdsUsername = localStorage[this.libraryId + '.cdsUsername'];
                        let cdsPassword = localStorage[this.libraryId + '.cdsPassword'];
                        if (cdsUsername && cdsUsername.length > 0) {
                            this.login(cdsUsername, cdsPassword, true, false).done(() => {
                                this.tryToLoadCatalogOfArgs();
                            });
                        } else {
                            this.login().done(() => {
                                this.tryToLoadCatalogOfArgs();
                            });
                        }

                    });
            } else {
                this.loadLibrary()
                    .done(() => {
                        this.getController('LibraryController').loadLibrary({
                            'library': this.library
                        });
                        this.tryToLoadCatalogOfArgs();
                    });
            }

        });

    }

    loadLibrary() {
        let libraryPath = this.baseUrl + this.libraryId + "-library.xml";
        let libraryURL = URLUtils.getURL(libraryPath);
        let libraryLoader = new LibraryLoader();

        let deferred = new $.Deferred();

        libraryLoader.load(libraryURL)
            .done((library) => {
                this.library = library;
                this.visualTemplate = library.visualTemplate;
                this.deviceLanguageList = (library.deviceLanguageList.length > 0) ? library.deviceLanguageList : this.viewerLanguageList;
                this.defaultLanguage = (library.defaultLanguage) ? library.defaultLanguage : this.defaultLanguage;
                this.currentDeviceLanguage = this.chooseLanguage(this.userLanguageList, this.deviceLanguageList, this.defaultLanguage);
                this.loadMessages().done(() => {
                    deferred.resolve();
                });
            })
            .fail(deferred.reject);

        return deferred;
    }

    loadCDSConfig() {
        let cdsConfigPath = this.baseUrl + this.libraryId + "-cds-config.xml";
        let cdsConfigURL = URLUtils.getURL(cdsConfigPath);
        let cdsLoader = new CDSLoader();

        let deferred = new $.Deferred();

        cdsLoader.loadCDSConfig(cdsConfigURL)
            .done((cdsConfig) => {
                this.cdsConfig = cdsConfig;
                deferred.resolve();
            })
            .fail(deferred.resolve);

        return deferred;
    }

    login(username, password, remember = false, encryptPassword = true) {
        let cdsLoader = new CDSLoader();

        let deferred = new $.Deferred();

        this.cdsConfig.cdsUsername = (username) ? username : '';
        this.cdsConfig.cdsPassword = (password) ? ((encryptPassword) ? CryptoJS.MD5(password) : password) : '';

        if (this.cdsConfig.cdsUsername.length == 0 &&
            this.cdsConfig.cdsPassword.length == 0 &&
            !this.cdsConfig.cdsUseDefaultUsername) {

            $('#COIWebViewer').empty();

            let textUsername = this.polyglot.t("Username");
            let textPassword = this.polyglot.t("Password");
            let textRemember = this.polyglot.t("Remember");
            let textLogin = this.polyglot.t("Login");

            $('#loginDialog').remove();

            let loginClicked = false;
            let d = $('<div>', {
                id: 'loginDialog',
                title: textLogin,
                html: '<label for="login_username">'+textUsername+':</label><br/><input type="text" id="login_username"/><br/>' +
                '<label for="login_password">'+textPassword+':</label><br/><input type="password" id="login_password"/><br/>' +
                '<input type="checkbox" id="login_remember"><label for="login_remember" style="margin-left:5px;">'+textRemember+'</label>',
                keypress: function(e) {
                    if (e.keyCode == $.ui.keyCode.ENTER) {
                        $('#loginButton').trigger("click");
                    }
                }
            }).dialog({
                modal: true,
                close: () => {
                    if (!loginClicked) this.run();
                },
                buttons: [
                    {
                        id: 'loginButton',
                        text: textLogin,
                        click: () => {
                            loginClicked = true;
                            let username = d.children('#login_username').val();
                            let password = d.children('#login_password').val();
                            let remember = d.children('#login_remember').is(':checked');
                            $('#loginDialog').dialog("close");
                            this.login(username, password, remember);
                        }
                    }
                ]
            });

        } else {

            cdsLoader.loadCDSResponse(this.cdsConfig)
                .done((cdsResponse) => {
                    if (cdsResponse.code == "OK") {

                        if (remember) {
                            localStorage[this.libraryId + '.cdsUsername'] = this.cdsConfig.cdsUsername;
                            localStorage[this.libraryId + '.cdsPassword'] = this.cdsConfig.cdsPassword;
                        }

                        this.loadLibrary().done(() => {
                            CDSFilter.filterLibrary(this.library, cdsResponse.publications);

                            this.getController('LibraryController').loadLibrary({
                                'library': this.library
                            });

                            deferred.resolve();
                        });
                    } else {
                        let textError = this.polyglot.t("Error");
                        let textOK = this.polyglot.t("OK");

                        let d = $('<div>', {
                            title: textError,
                            html: `<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span>${cdsResponse.message}</p>`
                        }).dialog({
                            modal: true,
                            close: this.run.bind(this),
                            buttons: [
                                {
                                    text: textOK,
                                    click: () => { d.dialog("close"); }
                                }
                            ]
                        });
                        deferred.resolve();
                    }

                })
                .fail(() => {
                    let textError = this.polyglot.t("Error");
                    let textOK = this.polyglot.t("OK");

                    let d = $('<div>', {
                        title: textError,
                        html: `<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span>No se ha podido conectar con el servidor.</p>`
                    }).dialog({
                        modal: true,
                        close: this.run.bind(this),
                        buttons: [
                            {
                                text: textOK,
                                click: () => { d.dialog("close"); }
                            }
                        ]
                    });
                    deferred.reject();
                })
        }

        return deferred;
    }

    logout() {
        localStorage[this.libraryId + '.cdsUsername'] = '';
        localStorage[this.libraryId + '.cdsPassword'] = '';
        this.login();
    }

    renderView(view, model) {
        super.renderView(view, model);
        this.viewStack.push([view, model]);
        this.render();
    }

    goBack() {
        let numViews = this.viewStack.length;
        if (numViews > 1) {
            this.viewStack.pop();
            this.render();
        }
    }

    render() {
        $('#COIWebViewer').empty();
        let numViews = this.viewStack.length;
        if (numViews > 0) {
            let currentView = this.viewStack[numViews-1][0];
            let currentModel = this.viewStack[numViews-1][1];
            currentView.createView(currentModel, $('#COIWebViewer')).appendTo('#COIWebViewer');
            currentView.onRendered();
        }
        // Slider
        $('#slides').slidesjs(this.bannerSliderOptions);
    }

    chooseLanguage(preferredLanguages, availableLanguages, fallbackLanguage) {
        for (let lang of preferredLanguages) {
            if ($.inArray(lang, availableLanguages) >= 0) {
                return lang;
            }
        }
        return fallbackLanguage;
    }

    changeCurrentLanguage(lang) {
        this.currentDeviceLanguage = lang;
        this.loadMessages().done(() => {
            this.getController('LibraryController').loadLibrary({ 'library': this.library });
        });
    }

    loadMessages() {
        let deferred = new $.Deferred();

        let messagesJsonPath = 'resources/messages.' + this.currentDeviceLanguage + '.json';
        let messagesJsonURL = URLUtils.getURL(messagesJsonPath);
        $.getJSON(messagesJsonURL)
            .done((json) => {
                this.polyglot = new Polyglot();
                this.polyglot.locale(this.currentDeviceLanguage);
                this.polyglot.extend(json);
                deferred.resolve();
            })
            .fail(deferred.reject);

        return deferred;
    }

    loadCatalogById(catalogId, fromRoot = false) {
        let catalogList = this.library.getRecursiveCatalogList();
        catalogList = LibraryCatalogFilter.filter(catalogList, {
            'deviceType': this.currentDeviceType,
            'deviceLanguage': this.currentDeviceLanguage,
            'catalogId': catalogId
        });

        if (catalogList.length > 0) {

            if (fromRoot) {
                let catalogsToLoad = [];
                let currentCatalog = catalogList[0];

                while (currentCatalog != undefined) {
                    catalogsToLoad.push(currentCatalog);
                    currentCatalog = currentCatalog._parent;
                }

                this.viewStack = this.viewStack.slice(0,1);

                while (catalogsToLoad.length > 0) {
                    currentCatalog = catalogsToLoad.pop();
                    this.getController('LibraryController').loadLibraryCatalog({
                        'libraryCatalog': currentCatalog
                    });
                }

            } else {
                this.getController('LibraryController').loadLibraryCatalog({
                    'libraryCatalog': catalogList[0]
                });
            }

        } else {
            $('<div>', {
                title: 'Error',
                html: '<p><span class="ui-icon ui-icon-alert" style="float:left; margin:0 7px 50px 0;"></span> Publicación no disponible.</p>'
            }).dialog({
                modal: true,
                closeOnEscape: true
            });
        }
    }

    tryToLoadCatalogOfArgs() {
        if (this.catalogId) {
            this.loadCatalogById(this.catalogId, true);
        }
    }

    initializePolyfills() {
        PointerEventsPolyfill.initialize({});
    }

    isSupportedBrowser() {
        if (bowser.msie && bowser.version <= 11) {
            return false;
        }
        return true;
    }

    printHeader() {
        console.log("480i Visor Web - version: " + this.currentViewerVersion);
    }

    onResize() {
        //console.log("WebViewer onResize");

    }

}
